import * as React from "react";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

type Props = {
    children?: React.ReactNode;
    transitionName: string;
};

export const AnimationDropdownMenu = ({ transitionName, children }: Props) => (
    <ReactCSSTransitionGroup
        className="dropdown-menu-item-animation"
        transitionName={transitionName}
        transitionAppear
        transitionLeave
        transitionAppearTimeout={0}
        transitionEnterTimeout={0}
        transitionLeaveTimeout={0}>
        {children}
    </ReactCSSTransitionGroup>
);
